import { useState, useEffect } from "react";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import CustomSelect from "../CustomSelect";

const TrainerModuli = ({ moduliProtocollati, operatorView }) => {
  const [moduli, setModuli] = useState(
    Array.isArray(moduliProtocollati?.content)
      ? moduliProtocollati.content
      : Array.isArray(moduliProtocollati)
      ? moduliProtocollati
      : []
  );
  const [editingModuloId, setEditingModuloId] = useState(null);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const data =
      Array.isArray(moduliProtocollati) && moduliProtocollati.length > 0
        ? moduliProtocollati
        : Array.isArray(moduliProtocollati?.content)
        ? moduliProtocollati.content
        : [];
    setModuli(data);
  }, [moduliProtocollati]);

  const modalitàErogazioneOptions = [
    { value: "Fad", label: "Fad" },
    { value: "Presenza", label: "Presenza" },
    { value: "Entrambi", label: "Entrambi" },
  ];

  const previsteDispenseOptions = [
    { value: "No", label: "No" },
    { value: "Sì, libro", label: "Sì, libro" },
    { value: "Sì, elaborati", label: "Sì, elaborati" },
  ];

  const proveFinaliOptions = [
    { value: "No", label: "No" },
    { value: "Sì, orale", label: "Sì, orale" },
    { value: "Sì, scritta", label: "Sì, scritta" },
  ];

  const getLabel = (options, value) =>
    options.find((opt) => opt.value === value)?.label || value;

  const handleEditClick = (modulo) => {
    // Prevent multiple edit modes at once
    if (editingModuloId && editingModuloId !== modulo.idModuloTrainer) {
      toast.warn("Puoi modificare solo un modulo alla volta!", {
        position: "top-right",
        autoClose: 3000,
        transition: Bounce,
      });
      return;
    }

    setEditingModuloId(modulo.idModuloTrainer);
    setForm({
      titoloModulo: modulo.titoloModulo || "",
      oreModulo: modulo.oreModulo || "",
      modalitàErogazione: modulo.modalitàErogazione || "",
      materialeAttrezzature: modulo.materialeAttrezzature || "",
      previsteDispense: modulo.previsteDispense || "",
      proveFinali: modulo.proveFinali || "",
      trainerCodiceFiscale: modulo.trainer?.codiceFiscale || "",
    });
    setErrors({});
  };

  const handleCancel = () => {
    setEditingModuloId(null);
    setForm({});
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") delete newErrors[name];
      return newErrors;
    });
  };

  const validate = () => {
    const inputErrors = {};
    if (!form.titoloModulo.trim()) {
      inputErrors.titoloModulo =
        "Il campo Titolo del modulo non può essere vuoto!";
    }
    if (!form.oreModulo || isNaN(form.oreModulo)) {
      inputErrors.oreModulo = "Il campo Ore del modulo non può essere vuoto!";
    }
    if (!form.modalitàErogazione.trim()) {
      inputErrors.modalitàErogazione =
        "Il campo Modalità di erogazione non può essere vuoto!";
    }
    if (!form.materialeAttrezzature.trim()) {
      inputErrors.materialeAttrezzature =
        "Il campo Materiale e attrezzature non può essere vuoto!";
    }
    if (!form.previsteDispense.trim()) {
      inputErrors.previsteDispense =
        "Il campo Dispense previste non può essere vuoto!";
    }
    if (!form.proveFinali.trim()) {
      inputErrors.proveFinali = "Il campo Prove finali non può essere vuoto!";
    }
    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async (idModuloTrainer) => {
    if (!validate()) return;
    try {
      setLoading(true);
      const response = await api.put(
        `/moduli-protocollati/${idModuloTrainer}`,
        {
          ...form,
          oreModulo: parseInt(form.oreModulo),
        }
      );

      if (response.status === 200) {
        toast.success("Modifiche salvate con successo!", {
          position: "top-right",
          autoClose: 5000,
          transition: Bounce,
        });

        setModuli((prev) =>
          prev.map((m) =>
            m.idModuloTrainer === idModuloTrainer ? { ...m, ...form } : m
          )
        );

        setEditingModuloId(null);
      } else {
        toast.error("Errore nel salvataggio!", { position: "top-right" });
      }
    } catch (error) {
      console.error(error);
      toast.error("Errore durante il salvataggio!", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="trainer-moduli-protocollati">
      <div className="trainer-moduli-protocollati-title">
        Moduli Protocollati
      </div>
      <div className="trainer-data-fields">
        {Array.isArray(moduli) && moduli.length > 0 ? (
          moduli.map((modulo) => {
            const isEditing = editingModuloId === modulo.idModuloTrainer;
            return (
              <div key={modulo.idModuloTrainer} className="trainer-data">
                {/* Titolo Modulo */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Titolo Modulo:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        type="text"
                        name="titoloModulo"
                        value={form.titoloModulo}
                        onChange={handleChange}
                        className={errors.titoloModulo ? "error" : ""}
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.titoloModulo}
                      </span>
                    )}
                    {errors.titoloModulo && (
                      <span className="error">{errors.titoloModulo}</span>
                    )}
                  </div>
                </div>

                {/* Ore */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Ore:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        type="number"
                        name="oreModulo"
                        value={form.oreModulo}
                        onChange={handleChange}
                        className={errors.oreModulo ? "error" : ""}
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.oreModulo}
                      </span>
                    )}
                    {errors.oreModulo && (
                      <span className="error">{errors.oreModulo}</span>
                    )}
                  </div>
                </div>

                {/* Modalità Erogazione */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">
                    Modalità Erogazione:
                  </div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <CustomSelect
                        options={modalitàErogazioneOptions}
                        value={
                          form.modalitàErogazione
                            ? {
                                value: form.modalitàErogazione,
                                label: getLabel(
                                  modalitàErogazioneOptions,
                                  form.modalitàErogazione
                                ),
                              }
                            : null
                        }
                        onChange={(selected) =>
                          handleChange({
                            target: {
                              name: "modalitàErogazione",
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Seleziona modalità"
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.modalitàErogazione}
                      </span>
                    )}
                    {errors.modalitàErogazione && (
                      <span className="error">{errors.modalitàErogazione}</span>
                    )}
                  </div>
                </div>

                {/* Materiale Attrezzature */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">
                    Materiale Attrezzature:
                  </div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <input
                        type="text"
                        name="materialeAttrezzature"
                        value={form.materialeAttrezzature}
                        onChange={handleChange}
                        className={errors.materialeAttrezzature ? "error" : ""}
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.materialeAttrezzature}
                      </span>
                    )}
                    {errors.materialeAttrezzature && (
                      <span className="error">
                        {errors.materialeAttrezzature}
                      </span>
                    )}
                  </div>
                </div>

                {/* Previste Dispense */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Previste Dispense:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <CustomSelect
                        options={previsteDispenseOptions}
                        value={
                          form.previsteDispense
                            ? {
                                value: form.previsteDispense,
                                label: getLabel(
                                  previsteDispenseOptions,
                                  form.previsteDispense
                                ),
                              }
                            : null
                        }
                        onChange={(selected) =>
                          handleChange({
                            target: {
                              name: "previsteDispense",
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Seleziona dispense"
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.previsteDispense}
                      </span>
                    )}
                    {errors.previsteDispense && (
                      <span className="error">{errors.previsteDispense}</span>
                    )}
                  </div>
                </div>

                {/* Prove Finali */}
                <div className="trainer-field-row">
                  <div className="trainer-field-label">Prove Finali:</div>
                  <div className="trainer-field-value">
                    {isEditing ? (
                      <CustomSelect
                        options={proveFinaliOptions}
                        value={
                          form.proveFinali
                            ? {
                                value: form.proveFinali,
                                label: getLabel(
                                  proveFinaliOptions,
                                  form.proveFinali
                                ),
                              }
                            : null
                        }
                        onChange={(selected) =>
                          handleChange({
                            target: {
                              name: "proveFinali",
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Seleziona prove finali"
                      />
                    ) : (
                      <span className="trainer-span-value">
                        {modulo.proveFinali}
                      </span>
                    )}
                    {errors.proveFinali && (
                      <span className="error">{errors.proveFinali}</span>
                    )}
                  </div>
                </div>

                {/* Actions */}
                {!operatorView && (
                  <div className="trainer-edit-actions">
                    {isEditing ? (
                      <>
                        <button
                          type="button"
                          className="save-btn"
                          onClick={() => handleSave(modulo.idModuloTrainer)}
                          disabled={loading}
                        >
                          Salva
                        </button>
                        <button
                          onClick={handleCancel}
                          disabled={loading}
                          type="button"
                          className="cancel-btn"
                        >
                          Annulla
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={() => handleEditClick(modulo)}
                        className="edit-btn"
                      >
                        Modifica
                      </button>
                    )}
                  </div>
                )}

                <hr />
              </div>
            );
          })
        ) : (
          <div className="no-data">Nessun modulo disponibile.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerModuli;
